/* assets/wishlist.local.js */
(function () {
  const KEY = 'wl_v1';
  const API = (window.WL && WL.proxyURL) || '/apps/wishlist';

  const getLocal = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  };

  const setLocal = (arr) => {
    localStorage.setItem(KEY, JSON.stringify([...new Set(arr.map(String))]));
  };

  async function getRemote(cid) {
    const url = cid ? `${API}?cid=${encodeURIComponent(cid)}` : API;
    const r = await fetch(url, { credentials: 'same-origin' });
    if (!r.ok) return null;
    try { return await r.json(); } catch { return null; }
  }

  async function setRemote(cid, items) {
    const r = await fetch(API, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cid, items }),
    });

    if (!r.ok) return null;
    return await r.json().catch(() => null);
  }

  let list = getLocal().map(String);
  let dirty = false;
  let booting = false;

  let saveTimer = null;
  let saveInFlight = false;
  let saveAgain = false;
  let saveVersion = 0;

  const isLoggedIn = () => !!(window.WL && (WL.loggedIn || WL.cid != null));

  const getCid = () => {
    if (!window.WL || WL.cid == null) return null;
    return String(WL.cid).startsWith('cust-') ? String(WL.cid) : `cust-${WL.cid}`;
  };

  function updateBadge() {
    document.querySelectorAll('.wishlist-link__count').forEach(el => {
      const n = Array.isArray(list) ? list.length : 0;
      el.textContent = n;
      el.style.display = 'inline-block';
      el.classList.toggle('is-nonzero', n > 0);
      el.classList.toggle('is-zero', n === 0);
    });

    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: { count: list.length, items: list.slice() }
    }));
  }

  function markHandle(handle, on) {
    if (!handle) return;

    document
      .querySelectorAll(`.wl-btn[data-handle="${CSS.escape(handle)}"]`)
      .forEach(btn => {
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
  }

  function markAll() {
    document.querySelectorAll('.wl-btn').forEach(btn => {
      const h = btn.dataset.handle;
      const on = !!h && list.includes(String(h));
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  async function boot() {
    if (dirty || booting || saveInFlight) return;

    booting = true;

    try {
      if (isLoggedIn()) {
        const cid = getCid();
        const remote = await getRemote(cid);

        if (!dirty && !saveInFlight && Array.isArray(remote)) {
          list = [...new Set(remote.map(String))];
          setLocal(list);
        } else if (!dirty && !saveInFlight) {
          list = getLocal().map(String);
          queueSave();
        }
      } else {
        list = getLocal().map(String);
      }

      markAll();
      updateBadge();
    } finally {
      booting = false;
    }
  }

  function queueSave() {
    if (!isLoggedIn()) return;

    clearTimeout(saveTimer);
    saveTimer = setTimeout(runSave, 450);
  }

  async function runSave() {
    if (saveInFlight) {
      saveAgain = true;
      return;
    }

    saveInFlight = true;

    const myVersion = saveVersion;
    const snapshot = [...new Set(list.map(String))];

    try {
      const data = await setRemote(getCid(), snapshot);

      // If user clicked again after this save started, ignore this response
      if (myVersion !== saveVersion) {
        return;
      }

      // Only accept server-cleaned list if no newer click happened
      if (data && Array.isArray(data.items)) {
        list = [...new Set(data.items.map(String))];
        setLocal(list);
      }

      dirty = false;
      markAll();
      updateBadge();
    } catch (err) {
      console.warn('[wl] save failed', err);
    } finally {
      saveInFlight = false;

      if (saveAgain) {
        saveAgain = false;
        queueSave();
      }
    }
  }

  function toggle(handle) {
    if (!handle) return;

    handle = String(handle);

    const i = list.indexOf(handle);
    const on = i < 0;

    if (on) list.push(handle);
    else list.splice(i, 1);

    list = [...new Set(list.map(String))];

    dirty = true;
    saveVersion++;

    setLocal(list);
    markHandle(handle, on);
    updateBadge();

    queueSave();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wl-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    toggle(btn.dataset.handle);
  });

  document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', () => {
    if (!dirty && !saveInFlight) boot();
    else {
      markAll();
      updateBadge();
    }
  });

  window.addEventListener('storage', (ev) => {
    if (ev.key === KEY && !dirty && !saveInFlight) {
      list = getLocal().map(String);
      markAll();
      updateBadge();
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && !dirty && !saveInFlight) {
      boot();
    }
  });
})();